// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";
import { useLocalizedHref } from "@libraries/web-framework";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { N0 } from "@atlaskit/theme/colors";
import { token } from "@atlaskit/tokens";

import Button from "@/components/wpl/button/src";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const h2Style = css`
    font-weight: 500;
    text-align: center;
    color: ${N0};
    margin: 0;

    @media (max-width: 47.99rem) {
      font-size: 2rem;
      line-height: 2.375rem;
    }

    @media (min-width: 48rem) and (max-width: 63.99rem) {
      font-size: 2.25rem;
      line-height: 2.625rem;
    }

    @media (min-width: 64rem) {
      font-size: 2.5rem;
      line-height: 3rem;
    }
  }
`;

const buttonContainer = css`
    padding: 16px;
`;

const CtaSection = () => {
    const intl = useIntl();

    const linkText = intl.formatMessage({
        id: "ConfluenceSoftwarePageTemplate.ctaSection.button",
        defaultMessage: "Get it free"
    });

    const buttonDataEventProps: DataEventProps = {
        "data-product-key": "confluence",
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-label": linkText,
        "data-label-english": "Get it free"
    };

    return (
        <section
            css={css`
                display: flex;
                flex-direction: column;
                align-items: center;
                background-color: #4c9aff;
                padding: ${token("space.400")} ${token("space.200")};

                ${media.above.sm} {
                    padding: ${token("space.1000")} 0;
                }
                ${media.above.md} {
                    background-image: url("https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:515850bc-bda7-4aa4-ad46-88ea178920c0/CTA_Graphic_Left.svg?cdnVersion=1267"),
                        url("https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:c72a51b6-9afc-40e4-a9ad-7179bfc03fde/CTA_Graphic_Right.svg?cdnVersion=1267");
                    background-position: center left, center right;
                    background-repeat: no-repeat, no-repeat;
                    background-size: auto 243px, auto 243px;
                }
            `}
        >
            <h2 css={h2Style}>
                {intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.ctaSection.trying.header",
                    defaultMessage: "Trying Confluence is easy — and free"
                })}
            </h2>
            <div css={buttonContainer}>
                <Button
                    color="yellow"
                    type="primary"
                    size="large"
                    url={useLocalizedHref(
                        "/try/cloud/signup?bundle=confluence&edition=free"
                    )}
                    text={linkText}
                    dataEventProps={buttonDataEventProps}
                />
            </div>
        </section>
    );
};

export default CtaSection;
